import React, {useContext, useEffect} from "react"
import {menuIsOpenContext} from "context/Navigation/menuIsOpen"

export const DefaultRoute = (props: any) => {
  const {update} = useContext(menuIsOpenContext)
  useEffect(() => {
    update(true)
  }, [update])
  return <h1>Backoffice</h1>
}